import { Divider } from 'antd';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';
import { RunbookDiff } from './diff-text';

import type { RunbookLog } from 'infrastructure/classes/runbook-log';
import type { FC } from 'react';

interface DiffSectionProps {
  oldData?: RunbookLog;
  currentData?: RunbookLog;
  current: boolean;
}

const DiffSection: FC<DiffSectionProps> = ({
  oldData,
  currentData,
  current,
}) => {
  const { t } = useTranslation();
  const name = current
    ? `${currentData?.updateByFullName ?? ''}${currentData?.createdAt ?? ''}`
    : `${oldData?.updateByFullName ?? ''}${oldData?.createdAt ?? ''}`;

  return (
    <div className={s['runbook-select-body']}>
      <div className={s['runbook-select-body-author']}>
        <div>{t('labels.electronicallySignedBy')}: </div>
        <div>{name}</div>
      </div>
      <Divider className={s['runbook-select-body-divider']} />
      <RunbookDiff oldData={oldData} newData={currentData} current={current} />
    </div>
  );
};
export default DiffSection;
